import * as React from 'react';

import * as styles from './styles.css';

import { UIHeading2 } from '@cian/ui-kit';

import imgSrc from './assets/img.svg';

interface IStickyFooterProps {
  title: string;
  isDesktop: boolean;
  primaryButton: React.ReactNode;
  secondaryButton: React.ReactNode;
}

export const StickyFooter: React.FC<IStickyFooterProps> = ({ isDesktop, title, primaryButton, secondaryButton }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        {isDesktop && (
          <div className={styles['heading']}>
            <img src={imgSrc} />
            <UIHeading2 color="text-primary-default">{title}</UIHeading2>
          </div>
        )}

        <div className={styles['buttons']}>
          {primaryButton}
          {secondaryButton}
        </div>
      </div>
    </div>
  );
};
